import { render, staticRenderFns } from "./AppTextarea.vue?vue&type=template&id=0310603a&scoped=true"
import script from "./AppTextarea.vue?vue&type=script&lang=js"
export * from "./AppTextarea.vue?vue&type=script&lang=js"
import style0 from "./AppTextarea.vue?vue&type=style&index=0&id=0310603a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0310603a",
  null
  
)

export default component.exports